<template>
  <v-row>
    <v-col cols="12">
      <base-card>
        <v-card-title>
          <router-link
            :to="`/app/administration/tefConfig`"
            @click.native=""
          >
            <v-icon
              class="mr-2"
              color="red darken-2"
              right
            >
              mdi-arrow-left-bold
            </v-icon>
          </router-link>
          Terminales [ {{ this.$route.query.Client }}]
          <v-spacer />
          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            label="Buscar"
            single-line
            hide-details
          />
          <v-spacer />
        </v-card-title>
        <v-alert
          v-show="copyAlert"
          type="info"
          text
        >
          {{ msgtokencopiado }}
        </v-alert>
        <v-alert
          v-show="deleteTerminalAlertStatus === false"
          type="success"
          text
        >
          {{ msgTerminalDeleted }}
        </v-alert>
        <v-alert
          v-show="deleteTerminalAlertStatus === true"
          type="warning"
          text
        >
          {{ msgTerminalNotDeleted }}
        </v-alert>
        <br>
        <v-card-text>
          <v-data-table
            :footer-props="{
              'items-per-page-text': 'filas por pagina',
            }"
            :headers="headers"
            :items="getListTerminalesbyTypeTef"
            :search="search"
            class="elevation-1"
          >
            <template v-slot:[`item.token_key`]="{ item }">
              <v-icon
                v-clipboard:copy="item.token_key"
                v-clipboard:success="onCopy"
                style="cursor:pointer;"
                color="info darken-3"
                class="mr-2"
              >
                mdi-content-copy
              </v-icon>
            </template>

            <template v-slot:[`item.data_integration`]="{ item }">
              <v-dialog
                max-width="1000"
                transition="dialog-bottom-transition"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-icon
                    class="mr-2"
                    color="info darken-3"
                    style="cursor:pointer;"
                    v-bind="attrs"
                    v-on="on"
                  >
                    mdi-cellphone-check
                  </v-icon>
                </template>
                <template v-slot:default="dialog">
                  <v-card>
                    <v-toolbar
                      dark
                      style="background-color:rgb(204 33 40);color:white !important"
                    >
                      DATOS INTERAGACIÓN TEF - CLIENTE [{{ item.client }}] - TERMINAL [{{ item.code_terminal }}]

                      <v-icon
                        style="margin-left: 460px !important;"
                        @click="dialog.value = false"
                      >
                        mdi-close
                      </v-icon>
                    </v-toolbar>

                    <campo-pinpad
                      v-if="item.tef_type_code === 1 || item.tef_type_code === 2"
                      :data-tef="typeof item.data_integration === 'string' ? JSON.parse(item.data_integration) : item.data_integration"
                      :token_key="item.token_key"
                      :code_store="item.code_store"
                    />
                  </v-card>
                </template>
              </v-dialog>
            </template>

            <template
              v-slot:[`item.editar`]="{ item }"
            >
              <v-dialog
                max-width="600"
                transition="dialog-bottom-transition"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-icon
                    class="mr-2"
                    color="orange darken-3"
                    style="cursor:pointer;"
                    v-bind="attrs"
                    v-on="on"
                  >
                    mdi-pencil
                  </v-icon>
                </template>
                <template v-slot:default="dialog">
                  <v-card>
                    <v-toolbar
                      dark
                      style="background-color:rgb(204 33 40);color:white !important"
                    >
                      TIEMPOS CONSULTA TEF - CLIENTE [{{ item.client }}] - TERMINAL [{{ item.code_store }}]

                      <v-icon
                        style="margin-left: 80px !important;"
                        @click="dialog.value = false"
                      >
                        mdi-close
                      </v-icon>
                    </v-toolbar>
                    <v-card-text>
                      <v-row>
                        <v-col
                          cols="12"
                          sm="6"
                        >
                          <v-subheader class="pl-0">
                            Tiempo Inicial de Consulta
                          </v-subheader>
                          <br>
                          <v-slider
                            v-model="dataTimeOuts.time_out_initial"
                            :thumb-size="24"
                            min="20"
                            max="60"
                            color="red"
                            track-color="gray"
                            thumb-label="always"
                          />
                        </v-col>

                        <v-col
                          cols="12"
                          sm="6"
                        >
                          <v-subheader class="pl-0">
                            Tiempo Secuencial de Consulta
                          </v-subheader>
                          <br>
                          <v-slider
                            v-model="dataTimeOuts.time_out_sequential"
                            :thumb-size="24"
                            min="4"
                            max="20"
                            color="red"
                            track-color="gray"
                            thumb-label="always"
                          />
                        </v-col>
                      </v-row>
                    </v-card-text>
                    <v-card-actions class="justify-end">
                      <v-btn
                        text
                        style="background-color:rgb(204 33 40);color:white !important"
                        @click="updateDataTimeout(item)"
                      >
                        Actualizar
                      </v-btn>
                    </v-card-actions>
                    <v-alert
                      v-show="successAlert"
                      type="success"
                      text
                    >
                      {{ msgSuccessAlert }}
                    </v-alert>
                  </v-card>
                </template>
              </v-dialog>
            </template>

            <template v-slot:[`item.eliminar`]="{ item }">
              <v-icon
                style="cursor:pointer;text-align-last: center;"
                color="red darken-3"
                class="mr-2"
                @click="openDialog(item)"
              >
                mdi-delete
              </v-icon>
            </template>
          </v-data-table>
        </v-card-text>
      </base-card>
    </v-col>
    <v-dialog
      v-model="dialog"
      max-width="500px"
    >
      <v-card>
        <v-card-title class="text-h5">
          Confirmar eliminación
        </v-card-title>
        <v-card-text>
          ¿Estás seguro de que deseas eliminar el Terminal: {{ selectedItem ? selectedItem.code_terminal : '' }} ?
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            style="background-color:rgb(204 33 40);color:white !important"
            @click="confirmDelete"
          >
            Eliminar
          </v-btn>
          <v-btn @click="closeDialog">
            Cancelar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>
<script>
  import { mapState } from 'vuex'

  export default {
    name: 'ShowCredentialTerminalsTef',
    components: {
      CampoPinpad: () => import('./datafast/CamposPinpad.vue'),
    },
    data () {
      return {
        progress: false,
        search: '',
        copyAlert: false,
        dataTimeOuts: [],
        successAlert: false,
        dialog: false,
        selectedItem: null,
        deleteTerminalAlertStatus: null,
        msgTerminalDeleted: 'Terminal eliminado correctamente',
        msgTerminalNotDeleted: 'El Terminal no pudo ser eliminado',
        msgtokencopiado: 'Token Copiado',
        msgSuccessAlert: 'Datos actualizados exitosamente',
        headers: [
          {
            text: 'Token Key',
            value: 'token_key',
          },
          {
            text: 'Cod Terminal Hiopos',
            value: 'code_terminal',
            align: 'center',
          },
          {
            text: 'Datos TEF',
            value: 'data_integration',
          },
          {
            text: 'Tiempo inicial de consulta',
            value: 'timeout_transaction',
            align: 'center',

          },
          {
            text: 'Tiempo secuencial de consulta',
            value: 'timeout_sequential',
            align: 'center',

          },
          {
            text: 'Editar',
            value: 'editar',

          },
          {
            text: 'Fecha Creación',
            value: 'created_at',
          },
          {
            text: 'Usuario Creación',
            value: 'created_by',
          },
          {
            text: 'Fecha Actualización',
            value: 'updated_at',
          },
          {
            text: 'Usuario Actualización',
            value: 'updated_by',
          },
          // {    // Comentado para deshabilitar función de eliminar credencial
          //   text: 'Eliminar',
          //   value: 'eliminar',
          // },
        ],

      }
    },
    computed: {
      ...mapState('credentialsTef', [
        'listTerminales', 'updateStatusTimeOutResponse',
      ]),

      getListTerminalesbyTypeTef () {
        return this.$store.state.credentialsTef.listTerminales.filter(el => el.tef_type_code == this.$route.query.Tef)
      },
      updateStatusTimeOutResponse () {
        return this.$store.state.credentialsTef.updateStatusTimeOutResponse
      },
      updateResponseDeleteTerminal () {
        return this.$store.state.credentialsTef.statusDeleteTerminalResponse
      },

    },
    watch:
      {
        updateStatusTimeOutResponse  () {
          if (this.updateStatusTimeOutResponse == true) {
            this.generateAlertSuccess()
            this.$store.dispatch('credentialsTef/setUpdateResponseTimeOut', false)
          }
        },
        updateResponseDeleteTerminal () {
          if (this.updateResponseDeleteTerminal !== null) {
            this.deleteTerminalAlertStatus = this.updateResponseDeleteTerminal
            this.generateTerminalDeletedAlert()
            this.$store.dispatch('credentialsTef/setUpdateResponseDeleteTerminal', null)
          }
        },
      },
    created () {
      this.getListTerminales()
    },
    methods: {
      openDialog (item) {
        this.selectedItem = item
        this.dialog = true
      },
      closeDialog () {
        this.dialog = false
        this.selectedItem = null
      },
      confirmDelete () {
        this.deleteTerminal(this.selectedItem)
        this.closeDialog()
      },
      async getListTerminales () {
        await this.$store.dispatch('credentialsTef/getListTerminales', this.$route.query)
      },
      generateAlertSuccess () {
        this.successAlert = true
        setTimeout(() => {
          this.successAlert = false
        }, 3000)
      },
      onCopy (e) {
        this.generateAlertCopy()
      },
      generateAlertCopy () {
        this.copyAlert = true
        setTimeout(() => {
          this.copyAlert = false
        }, 2000)
      },
      generateTerminalDeletedAlert () {
        this.$store.dispatch('credentialsTef/getListTerminales', this.$route.query)
        setTimeout(() => {
          this.deleteTerminalAlertStatus = null
        }, 3000,
        )
      },
      async updateDataTimeout (item) {
        this.dataTimeOuts.token_key = item.token_key
        this.dataTimeOuts.code_store = item.code_store
        this.dataTimeOuts.user = JSON.parse(atob(localStorage.getItem('uid'))).user
        this.dataTimeOuts.observation = 'Updated Timeouts'
        await this.$store.dispatch('credentialsTef/updateCredentialsTimeOut', this.dataTimeOuts)
      },
      async deleteTerminal (item) {
        await this.$store.dispatch('credentialsTef/deleteTerminal', item)
      },
    },
  }
</script>
